import { render, staticRenderFns } from "./SensorDetail.vue?vue&type=template&id=3a53bc68&scoped=true&"
import script from "./SensorDetail.vue?vue&type=script&lang=js&"
export * from "./SensorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a53bc68",
  null
  
)

export default component.exports